/**
 * Simplified HTTP helpers backed by an Axios instance that already
 * handles MSAL token acquisition and transient-error retries via
 * interceptors (see axiosInstance.ts).
 *
 * No msalInstance prop-drilling is needed – just pass the URL (and
 * body for POST).
 */
import axiosInstance from './axiosInstance';

export async function httpGet<T>(url: string): Promise<T> {
  const response = await axiosInstance.get<T>(url);
  return response.data;
}

export async function httpPost<TRequest, TResponse>(
  url: string,
  body: TRequest,
): Promise<TResponse> {
  const response = await axiosInstance.post<TResponse>(url, body);
  return response.data;
}

export async function httpPut<TRequest, TResponse>(
  url: string,
  body: TRequest,
): Promise<TResponse> {
  const response = await axiosInstance.put<TResponse>(url, body);
  return response.data;
}
